import React from 'react'
import './web.css'

function Web() {
    return (
        <div className='web'>
            <div className='web-option'>
                <a href='#projects'>
                    <img src='/icon2.png' className='option-icon'></img>Projects
                </a>
            </div>
            <div className='web-option'>
            <a href='#skills'>
                    <img src='/icon3.png' className='option-icon'></img>Skills
                </a>
            </div>
            {/*<div className='web-option'>
                <a href='#work'>
                    <img src='/icon4.png' className='option-icon'></img>Work
                </a>
            </div>*/}
            <div className='web-option'>
                <a href='https://drive.google.com/file/d/175ad9u99X6Nd-gf7_3s0OBgpQ7ywgMDA/view?usp=share_link'>
                    <img src='/icon4.png' className='option-icon'></img>Transcript
                </a>
            </div>
            <div className='web-option'>
                <a href='#contact'>
                    <img src='/icon5.png' className='option-icon'></img>Contact
                </a>
            </div>
            <div className='web-option'>
                <a href='#contact'>
                    <img src='/icon3.png' className='option-icon'></img>Resume
                </a>
            </div>

        </div>
    )
}

export default Web
